/**
 * Telegram WebApp SDK integration.
 * Provides access to Telegram Mini App features.
 */

declare global {
  interface Window {
    Telegram?: {
      WebApp: TelegramWebApp;
    };
  }
}

interface TelegramWebApp {
  initData: string;
  initDataUnsafe: {
    user?: {
      id: number;
      first_name: string;
      last_name?: string;
      username?: string;
    };
  };
  colorScheme: 'light' | 'dark';
  themeParams: Record<string, string>;
  isExpanded: boolean;
  viewportHeight: number;
  viewportStableHeight: number;
  ready: () => void;
  expand: () => void;
  close: () => void;
  MainButton: {
    text: string;
    color: string;
    textColor: string;
    isVisible: boolean;
    isActive: boolean;
    show: () => void;
    hide: () => void;
    onClick: (cb: () => void) => void;
  };
}

/**
 * Get the Telegram WebApp instance.
 */
export function getTelegramWebApp(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null;
}

/**
 * Get Telegram initData for API authentication.
 */
export function getInitData(): string {
  return getTelegramWebApp()?.initData ?? '';
}

/**
 * Initialize the Telegram Mini App.
 */
export function initTelegramApp(): void {
  const webapp = getTelegramWebApp();
  if (webapp) {
    webapp.ready();
    webapp.expand();
  }
}

/**
 * Check if running inside Telegram.
 */
export function isTelegramEnvironment(): boolean {
  return !!getTelegramWebApp()?.initData;
}
